import { computed, defineComponent, toRefs } from "@vue/composition-api";
import CurrencyField from "@Shared/components/form-elements/fields/currency-field.vue";
import SelectField from "@Shared/components/form-elements/fields/select-field.vue";
import PercentageField from "@Shared/components/form-elements/fields/percentage-field.vue";
import DateField from "@Shared/components/form-elements/fields/date-field.vue";
import TextField from "@Shared/components/form-elements/fields/text-field.vue";
import { APPLICATION_FIELD_OPTIONS } from "@Shared/@Utils/application-defaults-utils/global-field-options";
import DeleteElementIcon from "@Client/@Modules/application-standalone/components/helpers/delete-element-icon.vue";
import SectionTitle from "@Client/@Modules/application-standalone/components/helpers/section-title.vue";
import { useOtherPropertiesHelpers } from "@Client/@Composables/application-standalone/pages/other-properties/useOtherPropertiesHelpers";
import { otherPropertyExistingMortgageValidator } from "@Client/@Composables/application-standalone/validations/otherPropertyExistingMortgageValidator";
import { otherPropertiesExistingMortgageBindingsAndVisibilities } from "@Client/@Composables/application-standalone/pages/other-properties/otherPropertiesExistingMortgageBindingsAndVisibilities";
import { get } from "lodash";
export default defineComponent({
  name: "OtherPropertyExistingMortgage",
  components: {
    CurrencyField,
    SelectField,
    PercentageField,
    DateField,
    TextField,
    DeleteElementIcon,
    SectionTitle
  },
  props: {
    applicantIndex: {
      type: Number,
      required: true
    },
    otherPropertyIndex: {
      type: Number,
      required: true
    },
    existingMortgageIndex: {
      type: Number,
      required: true
    },
    applicantId: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const {
      applicantIndex,
      otherPropertyIndex,
      existingMortgageIndex,
      applicantId
    } = toRefs(props);
    const {
      mortgageTypeOptions,
      mortgageFrequencyOptions,
      mortgageRateTypeOptions,
      mortgageTermTypeOptions,
      mortgagePayoffOptions,
      mortgageLoanTypeOptions
    } = APPLICATION_FIELD_OPTIONS();
    const {
      bindings,
      visibilities
    } = otherPropertiesExistingMortgageBindingsAndVisibilities(applicantIndex, otherPropertyIndex, existingMortgageIndex, applicantId);
    const {
      existingMortgageBalanceRemaining,
      existingMortgageFrequency,
      existingMortgageInterestRate,
      existingMortgageLender,
      existingMortgageLoanType,
      existingMortgageMaturityDate,
      existingMortgageMortgageType,
      existingMortgageOrigAmount,
      existingMortgagePaymentAmount,
      existingMortgagePayoff,
      existingMortgageRateType,
      existingMortgageTermType
    } = bindings;
    const {
      deleteExistingMortgage
    } = useOtherPropertiesHelpers();
    const handleDeleteExistingMortgage = () => {
      deleteExistingMortgage(applicantIndex.value, otherPropertyIndex.value, existingMortgageIndex.value);
    };
    const {
      otherPropertyExistingMortgageBalanceRemainingVisibility,
      otherPropertyExistingMortgageFrequencyVisibility,
      otherPropertyExistingMortgageInterestRateVisibility,
      otherPropertyExistingMortgageLenderVisibility,
      otherPropertyExistingMortgageLoanTypeVisibility,
      otherPropertyExistingMortgageMaturityDateVisibility,
      otherPropertyExistingMortgageMortgageTypeVisibility,
      otherPropertyExistingMortgageOrigAmountVisibility,
      otherPropertyExistingMortgagePaymentAmountVisibility,
      otherPropertyExistingMortgagePayoffVisibility,
      otherPropertyExistingMortgageRateTypeVisibility,
      otherPropertyExistingMortgageTermTypeVisibility
    } = visibilities;
    const sectionVisible = computed(() => {
      return otherPropertyExistingMortgageBalanceRemainingVisibility.value || otherPropertyExistingMortgageFrequencyVisibility.value || otherPropertyExistingMortgageInterestRateVisibility.value || otherPropertyExistingMortgageLenderVisibility.value || otherPropertyExistingMortgageLoanTypeVisibility.value || otherPropertyExistingMortgageMaturityDateVisibility.value || otherPropertyExistingMortgageMortgageTypeVisibility.value || otherPropertyExistingMortgageOrigAmountVisibility.value || otherPropertyExistingMortgagePaymentAmountVisibility.value || otherPropertyExistingMortgagePayoffVisibility.value || otherPropertyExistingMortgageRateTypeVisibility.value || otherPropertyExistingMortgageTermTypeVisibility.value;
    });
    const {
      v$
    } = otherPropertyExistingMortgageValidator(applicantIndex, otherPropertyIndex, existingMortgageIndex);
    const getValidator = path => get(v$.value, path, null);
    return {
      existingMortgageBalanceRemaining,
      existingMortgageFrequency,
      existingMortgageInterestRate,
      existingMortgageLender,
      existingMortgageLoanType,
      existingMortgageMaturityDate,
      existingMortgageMortgageType,
      existingMortgageOrigAmount,
      existingMortgagePaymentAmount,
      existingMortgagePayoff,
      existingMortgageRateType,
      existingMortgageTermType,
      mortgageTypeOptions,
      mortgageFrequencyOptions,
      mortgageRateTypeOptions,
      mortgageTermTypeOptions,
      mortgagePayoffOptions,
      mortgageLoanTypeOptions,
      handleDeleteExistingMortgage,
      otherPropertyExistingMortgageBalanceRemainingVisibility,
      otherPropertyExistingMortgageFrequencyVisibility,
      otherPropertyExistingMortgageInterestRateVisibility,
      otherPropertyExistingMortgageLenderVisibility,
      otherPropertyExistingMortgageLoanTypeVisibility,
      otherPropertyExistingMortgageMaturityDateVisibility,
      otherPropertyExistingMortgageMortgageTypeVisibility,
      otherPropertyExistingMortgageOrigAmountVisibility,
      otherPropertyExistingMortgagePaymentAmountVisibility,
      otherPropertyExistingMortgagePayoffVisibility,
      otherPropertyExistingMortgageRateTypeVisibility,
      otherPropertyExistingMortgageTermTypeVisibility,
      sectionVisible,
      v$,
      getValidator
    };
  }
});